import { render, staticRenderFns } from "./PaymentCompletedPack.vue?vue&type=template&id=212ee504&scoped=true&"
import script from "./PaymentCompletedPack.vue?vue&type=script&lang=js&"
export * from "./PaymentCompletedPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ee504",
  null
  
)

export default component.exports